module.exports = __webpack_public_path__ + "media/fonts/Highway-Gothic-Wide.ttf-f46dae50443ced673af9d542b1027732.svg";